import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { fail } from 'assert';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AuthService } from '../../Services/auth.service';
import { CommonService } from '../../Services/common.service';
import { ConfigSettingService } from '../../Services/config-setting.service';
import { DataManipService } from '../../Services/data-manip.service';
import CryptoJS from "crypto-js";
import { EncrptDecreptService } from '../../Services/encrpt-decrept.service';
import { HelperService } from '../../Services/helper.service';
import { OwlOptions } from 'ngx-owl-carousel-o';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  selOption: string = "Register";
  regStatus = "";
  emailId: string = "";
  userName: string = "";
  lvUserName: string = "";
  userEmail: string = "";
  authCode: string = "";
  infoMsg: string = "";
  ErrorMsg: string = "";
  showSetPassword: boolean = false;
  showLoader: boolean = false;
  regEmailImgSrc: string = "";
  showSpinRegLoader: boolean = false;
  typeForPassword: string = 'password';
  typeForConPassword: string = 'password';
  sendLinkBtnDis: boolean = false;
  disableSendBtn: boolean = true;
  loginUser: boolean = false;
  forgotPassVisible: boolean = false;
  ForgotEmailInMsg: string = '';
  fgEmailId: string = '';
  operation: string = '';
  message: string = '';
  privateKey: string = 'viotalroot@123#';
  //Login TAB
  loginEmailId: string = "";//anand.bidnur@viotalworks.com
  loginPassword: string = "";
  ErrorLogInMsg: string = "";
  userId;
  setPassMsg: string = "";
  password: string = "";
  confPassword: string = "";
  showMsg: boolean = false;
  loginSuccess: boolean = false;
  newUserRegister: boolean = false;
  newUserRegisterInForgot: boolean = false;
  confirmPassErrMsg: string = "";
  passwordMatch: boolean = false;
  prefLang: string = "m";
  passCheckImgSrc: string = "";
  loginEmailImgSrc: string = "";
  showSpinLoginLoader: boolean = false;
  verifyCodeErrMsg: string = "";
  verifyCodeModal: boolean = false;
  masterTestData = [];
  selectedLang: string = "e";
  emailadd: string = '';
  showViewTestDetailsModal: boolean = false;
  userTestIndex: number = -1;
  verificationMsg = "";
  time: number = 10 * 60;
  fgTime: number = 5 * 60; //forgot timer
  showTime: any;
  showFgTime: any;
  showtimeline: boolean = false;
  resendBtnDisable: boolean = false;
  showforgottime: boolean = false;
  activeLink: number = 0;
  @ViewChild('setPasswordModal', { static: false }) public setPasswordModal: ModalDirective;
  @ViewChild('newUserMsgModal', { static: false }) public newUserMsgModal: ModalDirective;
  @ViewChild('verificationCodeModal', { static: false }) public verificationCodeModal: ModalDirective;
  @ViewChild('successModal', { static: false }) public successModal: ModalDirective;
  @ViewChild('verificationModal', { static: false }) public verificationModal: ModalDirective;

  @ViewChild('termsAndconditon', { static: false }) public termsAndconditon: ModalDirective;
  @ViewChild('privacyPolicy', { static: false }) public privacyPolicy: ModalDirective;
  @ViewChild('refundPolicy', { static: false }) public refundPolicy: ModalDirective;
  @ViewChild('shippingPolicy', { static: false }) public shippingPolicy: ModalDirective;
  @ViewChild('aboutInfo', { static: false }) public aboutInfo: ModalDirective;
  @ViewChild('contactInfo', { static: false }) public contactInfo: ModalDirective;
  @ViewChild('viewtestDetailModal', { static: false }) public viewtestDetailModal: ModalDirective;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    autoplay: true,
    dots: false,
    navSpeed: 700,
    navText: ['<', '>'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 4
      },
      940: {
        items: 4
      },
      1040: {
        items: 4
      }
    },
    nav: true
  }

  constructor(private helper: HelperService, private encryptService: EncrptDecreptService, private dataManipSrvc: DataManipService, private authService: AuthService, private router: Router, private commonServices: CommonService, private configSetting: ConfigSettingService) { }

  ngOnInit(): void {
    //this.logInEvt();
    this.getMasterTest();
  }

  resendCode() {

    this.showLoader = true;

    let apiUrl = this.configSetting.getBaseUrl() + "user/resendvcode";
    let body = {
      "emailid": this.emailId || this.loginEmailId
    }
    let params = { "criteria": body }
    this.authService.postMethod(apiUrl, params).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        this.verificationMsg = "Verification code has been resent successfully to your Email ID"
        this.message = "Verification code has been resent successfully to your email id.";
        this.successModal.show();
        setInterval(() => this.updateTime(this.time), 1000)
        this.resendBtnDisable = true;
        this.showtimeline = true;
      }
      else {
        this.verificationMsg = "Error Occured while resending code to your Email ID";

      }
    }, (err) => {
      //      console.log(err);
      this.showLoader = false;
    })
  }


  getMasterTest() {
    this.showLoader = true;
    let apiUrl = this.configSetting.getBaseUrl() + "user/getmastertest";

    this.authService.getMethod(apiUrl).subscribe(successResp => {
      this.showLoader = false;
      //  console.log("Tests: ",JSON.stringify(successResp));
      if (successResp['errorCode'] == "000000") {
        this.masterTestData = successResp["Data"]["mastertest"];
      }
      else {
        this.showLoader = false;
      }
    }, (err) => {
      //      console.log(err);
      this.showLoader = false;
    })
  }



  showTestDetails() {
    // console.log("EEEEEEE");
  }


  chooseOption(option) {
    // console.log("heloo")
    this.ErrorLogInMsg = "";
    this.loginPassword = "";
    this.selOption = option;
    // console.log(this.selOption);
    // console.log(1, this.loginEmailId, 2, this.emailId, 3, this.fgEmailId);

    this.resetReg();
    if (this.newUserRegister) {
      this.emailId = this.loginEmailId;
      this.checkEmailIdEvt('R')
      this.newUserRegister = false;
      this.newUserMsgModal.hide();
    } else if (this.newUserRegisterInForgot) {
      this.emailId = this.fgEmailId
      this.newUserRegisterInForgot = false;
      this.newUserMsgModal.hide();
    } else {
      this.loginEmailId = this.emailId;
      this.loginUser = false;
      this.checkEmailIdEvt('L')
    }
  }

  chooseLoginOption() {
    this.loginEmailId = this.userEmail;
    this.loginUser = false;
  }

  logInEvt() {
    this.showLoader = true;
    this.setPassMsg = "";
    this.ErrorLogInMsg = "";
    let apiUrl = this.configSetting.getBaseUrl() + "user/Login";
    let body = {
      "loginid": this.loginEmailId,
      "password": this.loginPassword
    }

    this.authService.postMethod(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        // console.log("Login .....", JSON.stringify(successResp));

        const userType = this.encryptService.decrypt(successResp["Data"]["userInfo"]["ut"]);
        successResp["Data"]["userInfo"]["ut"] = userType;
        this.dataManipSrvc.prefLanguage = successResp["Data"]["userInfo"]["preflanguage"];
        this.dataManipSrvc.userName = successResp["Data"]["userInfo"]["username"];
        const decreptedUserId = this.encryptService.decrypt(successResp["Data"]["userInfo"]["ui"])
        successResp["Data"]["userInfo"]["ui"] = decreptedUserId;
        this.dataManipSrvc.userId = successResp["Data"]["userInfo"]["ui"];
        this.dataManipSrvc.currentServerDate = successResp["Data"]["userInfo"]["currentdate"];
        this.dataManipSrvc.age = successResp["Data"]["userInfo"]["age"];
        if (successResp["Data"]["userInfo"]["dob"] == "0000-00-00") {
          successResp["Data"]["userInfo"]["dob"] = "";
        }
        this.dataManipSrvc.dob = successResp["Data"]["userInfo"]["dob"];
        this.dataManipSrvc.userimage = successResp["Data"]["userInfo"]["userprofileimage"]
        this.dataManipSrvc.apiToken = successResp["Data"]["token"];

        this.dataManipSrvc.emailId = successResp["Data"]["userInfo"]["emailid"];
        this.dataManipSrvc.mobileNo = successResp["Data"]["userInfo"]["mobileno"];


        // console.log(successResp["Data"]);

        if (!userType) {
          this.ErrorLogInMsg = "Invalid request. Please retry.";
          return;
        }
        //      console.log("ut", successResp["Data"]["userInfo"]["ut"]);

        if (successResp["Data"]["userInfo"]["ut"] == 'A') {
          this.router.navigateByUrl("/usermanagement");
          this.dataManipSrvc.isadmin = true;
        }
        else if (successResp["Data"]["userInfo"]["ut"] == 'S') {
          this.dataManipSrvc.isadmin = false;
          this.router.navigateByUrl("/dashboard");
        } else {
          this.ErrorLogInMsg = "Invalid request. Please retry.";
          return;
        }
        this.setPasswordModal.hide();
        localStorage.setItem("userdata", JSON.stringify(this.dataManipSrvc));


      }
      else {
        this.ErrorLogInMsg = successResp["errorDescription"];
      }
    }, (err) => {
      //      console.log(err);
      this.showLoader = false;
    })
  }

  checkEmailIdEvt(page) {

    // debugger;
    this.ErrorMsg = "";
    this.regStatus = "";
    this.regEmailImgSrc = "";
    let obj = {};
    this.showMsg = false;
    if (page == "L") {
      if (this.loginEmailId == "") return;
      this.showSpinLoginLoader = true;
      obj = { "emailid": this.loginEmailId };
    }
    else if (page == "R") {
      if (this.emailId == "") return;
      this.showSpinRegLoader = true;
      obj = { "emailid": this.emailId };
    } else if (page == "F") {
      if (this.fgEmailId == "") return;
      this.showSpinRegLoader = true;
      obj = { "emailid": this.fgEmailId };

    }

    let params = {};
    let email = obj['emailid'];
    let trimedEmail = email.trim();
    params = { 'emailid': trimedEmail }

    let apiUrl = this.configSetting.getBaseUrl() + "user/CheckEmailId";
    this.authService.getWithParams(apiUrl, params).subscribe(successResp => {
      this.showSpinRegLoader = false;
      this.showSpinLoginLoader = false;
      if (successResp['errorCode'] == "000000") {
        this.emailadd = params['emailid'];

        let decregstatus = this.encryptService.decrypt(successResp["Data"][0]["regstatus"]);
        let decuserid = +this.encryptService.decrypt(successResp["Data"][0]["userid"]);
        let decispassavl = this.encryptService.decrypt(successResp["Data"][0]["ispassavl"]);

        successResp["Data"][0]["regstatus"] = decregstatus;
        successResp["Data"][0]["userid"] = decuserid;
        successResp["Data"][0]["ispassavl"] = decispassavl;

        // console.log("Email Success...", successResp);
        this.lvUserName = successResp["Data"][0]["username"]
        this.userEmail = successResp["Data"][0]["pemailid"]
        this.regStatus = successResp["Data"][0]["regstatus"];
        this.userName = this.lvUserName;

        this.userId = successResp["Data"][0]["userid"];
        if (this.regStatus == "V" && page == "R") {
          this.showMsg = true;
          this.ErrorMsg = "This email is already registered, please log in.";
          this.message = "This email is already registered, please log in.";
          this.successModal.show();
          this.regEmailImgSrc = "../../../assets/img/form-loader/remove.png";
          this.disableSendBtn = true;
          // console.log('Here');

          this.chooseOption('Login');
          this.loginUser = true;
        } else if (successResp["Data"][0]["ispassavl"] == "N" && this.regStatus == "V" && page == "R") {
          this.setPasswordModal.show();
        }
        else if (successResp["Data"][0]["ispassavl"] == "N" && this.regStatus == "V" && page == "L") {
          this.setPasswordModal.show();
        }
        else if (this.regStatus == "P" && page == "L") {
          // console.log(this.regStatus == "P", "regstatus")
          this.verificationMsg = `${this.userEmail} this email id pending for verification.`;
          this.authCode = "";
          this.verifyCodeModal = true;
          this.verificationModal.show();
        }
        else if (this.regStatus == "P" && page == "R") {
          // console.log(this.regStatus == "P", "regstatus")
          // this.ErrorLogInMsg = "Email verification is pending.";
          this.showMsg = true;
          // this.ErrorMsg = "This email is already registered, please log in.";
          this.verificationMsg = `${this.userEmail} this email id pending for verification.`;

          this.authCode = "";
          this.verifyCodeModal = true;
          this.verificationModal.show();


        } else if (this.regStatus == "V" && page == "L") {
          this.forgotPassVisible = true;
        } else if (this.regStatus == "P" && page == "F") {
          // console.log(this.regStatus == "P","regstatus")
          // this.ErrorLogInMsg = "Email verification is pending.";
          this.showMsg = true;
          this.verificationMsg = "This email is pending for verification";
          this.disableSendBtn = true;
          this.verificationModal.show();
          this.ForgotEmailInMsg = "";
          this.verifyCodeModal = true;
        } else if (this.regStatus == "V" && page == "F") {
          // console.log(page);

          this.showMsg = true;
          this.disableSendBtn = false;
          this.ForgotEmailInMsg = "";
        } else if (successResp['Data'][0]['validemail'] == 'N') {
          this.ForgotEmailInMsg = successResp['errorDescription']
        } else if (successResp["Data"][0]["ispassavl"] == "Y" && this.regStatus == "V") {
          // this.chooseOption('Login');
          // console.log('Login Y V');

        } else if (this.regStatus == "P" && successResp["Data"][0]["ispassavl"] == "N") {
          //      console.log();

        }
      }
      else if (successResp['errorCode'] == 1012) {
        this.ForgotEmailInMsg = successResp['errorDescription'];
        this.disableSendBtn = true;


      } else {
        this.ForgotEmailInMsg = "This email id is not registered."
        if (page == "L") {
          this.userEmail = params['emailid'];
          this.newUserMsgModal.show();
        }
      }
      if (successResp["Data"]["validemail"]) {

        if (page == "R") {
          this.showMsg = true;
          this.ErrorMsg = successResp["errorDescription"];
          this.regEmailImgSrc = "../../../assets/img/form-loader/remove.png";
        }
        else if (page == "L") {
          this.ErrorLogInMsg = successResp["errorDescription"];
          this.loginEmailImgSrc = "../../../assets/img/form-loader/remove.png";
        }
      }
      else {
        if (page == "L") {
          this.newUserRegister = true;
          this.loginEmailImgSrc = "../../../assets/img/form-loader/check.png";
          // this.newUserMsgModal.show();

        }
        else if (page == "R") {
          this.regEmailImgSrc = "../../../assets/img/form-loader/check.png";
        }
        // this.ErrorLogInMsg = "Your email id is not registered, do you want to register? Yes No";
      }
    }, (err) => {
      //      console.log(err);
      this.showLoader = false;
    })
  }
  noRegister() {
    this.newUserRegister = false;
    this.loginEmailImgSrc = "";
  }
  newUserMsgModalClose() {
    this.newUserRegister = false;
    this.loginEmailImgSrc = "";
    this.ErrorLogInMsg = "";
    this.loginEmailId = "";
    this.loginPassword = "";
    this.emailId = '';
    this.loginEmailId = '';
    this.newUserMsgModal.hide();
  }

  clearPassMsg() {
    // this.confirmPassErrMsg = "";
  }

  registerUser() {
    // console.log("show the loader");

    this.showLoader = true;
    this.showMsg = false;
    let apiUrl = this.configSetting.getBaseUrl() + "user/registeruser";
    let email = this.emailId.toLowerCase();
    let body = {
      "svdf": this.encryptService.encrypt(email),
      "npoi": this.encryptService.encrypt(this.userName)
    }
    let param = { "criteria": body }
    this.authService.postMethod(apiUrl, param).subscribe(successResp => {
      setTimeout(() => {
        this.showLoader = false;
      }, 500);

      if (successResp['errorCode'] == "000000") {
        //  console.log("Register User.....", JSON.stringify(successResp));
        this.regStatus = successResp["Data"][0]["regstatus"];
        this.userId = successResp["Data"][0]["userid"];
        this.userEmail = successResp["Data"][0]["emailid"];
        this.lvUserName = successResp["Data"][0]["username"];
        this.showMsg = true;
        this.verificationMsg = "The verification code is sent to your email id.";
        this.verificationModal.show();
      }
    }, (err) => {
      //      console.log(err);
      this.showLoader = false;
    })

  }

  updateFgTime(time) {
    let min = Math.floor(time / 60).toString()
    let sec = Math.floor(time % 60).toString();

    min = min.length == 1 ? ("0" + min) : min;
    sec = sec.length == 1 ? ("0" + sec) : sec;

    this.showFgTime = `${min + ':' + sec}`;
    if (min == '00' && sec == '00') {
      this.showforgottime = false;
      this.forgotPassVisible = true;
      return;
    }

    this.fgTime--;
  }

  forgotPassword() {
    this.showLoader = true;

    let apiUrl = this.configSetting.getBaseUrl() + "user/forgotPassword";
    let email = this.loginEmailId.toLowerCase();

    let body = {
      "emailid": email,
    }
    let params = { "criteria": body }
    this.authService.postMethod(apiUrl, params).subscribe(successResp => {
      setTimeout(() => {
        this.showLoader = false;
      }, 500);
      if (successResp['errorCode'] == "000000") {
        //  console.log("Register User.....", JSON.stringify(successResp));
        this.message = `Dear <b>${successResp['Data'][0]['username']} </b>,</br> your password is sent to your registered email id <b>${successResp['Data'][0]['emailid']}.</b>`;

        this.successModal.show();
        this.showLoader = false;
        this.operation = 'Forgotemail';
        setInterval(() => this.updateFgTime(this.fgTime), 1000)
        this.showforgottime = true;
        this.forgotPassVisible = false;
      } else {
        this.message = `${successResp['errorDescription']}`;
        this.successModal.show();
        this.showLoader = false;
      }
    }, (err) => {
      //      console.log(err);
      this.showLoader = false;
    })
  }

  showSetPasswordModalEvt() {
    this.setPasswordModal.show();
  }

  verificationCodeModalClose() {
    this.verifyCodeModal = false;
    this.verifyCodeErrMsg = "";
    this.loginEmailId = "";
    this.loginPassword = "";
  }

  clearMsg() {
    this.ErrorMsg = "";
    this.infoMsg = "";
    this.loginPassword = "";
    this.ErrorLogInMsg = "";
    this.showMsg = false;
    this.newUserRegister = false;
    this.loginEmailImgSrc = "";
  }

  validateUserFromModal() {
    if (this.operation === 'Forgotemail') {
      this.emailId = this.fgEmailId;
    } else {
      this.emailId = this.loginEmailId;
    }
    this.validateUser();
  }

  validateUser() {
    // console.log(this.emailId);

    // let obj

    this.showLoader = true;
    this.showMsg = false;
    let params = { "qaz": this.emailId || this.loginEmailId, "plmk": this.authCode };

    let apiUrl = this.configSetting.getBaseUrl() + "user/validateOTP";
    this.authService.getWithParams(apiUrl, params).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        // console.log("Verify User.....", JSON.stringify(successResp));
        const isValidOTP = this.encryptService.decrypt(successResp["Data"]["asup"])
        successResp["Data"]['asup'] = isValidOTP;
        //      console.log(successResp["Data"]['asup']);

        if (!isValidOTP) {
          return;
        }
        if (successResp["Data"]['asup'].toLowerCase() == "invalid") {
          if (this.verifyCodeModal) {
            this.verifyCodeErrMsg = "Invalid verification code";
          }
          else {
            this.showMsg = true;
            this.verifyCodeErrMsg = "Invalid verification code";
          }
        }
        else if (successResp["Data"]['asup'].toLowerCase() == "valid") {
          this.loginEmailId = this.emailId;
          this.resetReg();
          this.setPasswordModal.show();
          // this.validateMsgModal.show();
          this.verificationModal.hide();
        }
      }
    }, (err) => {
      //      console.log(err);
      this.showLoader = false;
    })
  }

  checkPassword(eve, type) {
    //  console.log(this.password,this.confPassword,this.password === this.confPassword)
    //  console.log(eve,type,type == 'confirmpassword' && this.password == eve);
    if (this.confPassword && this.password) {

      // if (this.password != this.confPassword) {
      //   console.log("check pass",this.password != this.confPassword);
      //   this.passCheckImgSrc = "../../../assets/img/form-loader/remove.png";
      //   this.confirmPassErrMsg = "Password does not match."
      //   this.passwordMatch = false;
      // }
      // else {
      //   this.confirmPassErrMsg = "";
      //   this.passCheckImgSrc = "../../../assets/img/form-loader/check.png";
      //   this.passwordMatch = true;
      // }
      if (type == 'confirmpassword' && this.password == eve) {
        this.confirmPassErrMsg = "";
        this.passCheckImgSrc = "../../../assets/img/form-loader/check.png";
        this.passwordMatch = true;
      }
      else if (this.password !== this.confPassword) {
        this.passCheckImgSrc = "../../../assets/img/form-loader/remove.png";
        this.confirmPassErrMsg = "Password and confirmation password do not match."
        this.passwordMatch = false;
      } else {
        this.confirmPassErrMsg = "";
        this.passCheckImgSrc = "../../../assets/img/form-loader/check.png";
        this.passwordMatch = true;

      }

    }
    else {
      this.passCheckImgSrc = "";
    }
  }

  restrictChar(eve) {
    if (this.helper.restrictCharacters(eve.key)) {
      eve.preventDefault();
    }
  }


  viewTestDetails(i) {
    this.userTestIndex = i;
    this.viewtestDetailModal.show();
    this.showViewTestDetailsModal = true;
  }

  viewtestDetailModalClose() {
    this.showViewTestDetailsModal = false;
    this.viewtestDetailModal.hide();
    this.userTestIndex = -1;
  }

  termsCondition(val: number) {
    $('#termsconditionmodal').animate({
      scrollTop: 0
    }, 'slow');
    this.activeLink = val;
    this.termsAndconditon.show();
  }
  termsConditionClose(val: number) {
    this.activeLink = val;
    this.termsAndconditon.hide();
  }

  privacyPolicylink(val: number) {
    $('#privacypolicymodal').animate({
      scrollTop: 0
    }, 'slow');
    this.activeLink = val;
    this.privacyPolicy.show();
  }
  privacyPolicylinkClose(val: number) {
    this.activeLink = val;
    this.privacyPolicy.hide();
  }

  refundPolicylink(val: number) {
    $('#refundpolicymodal').animate({
      scrollTop: 0
    }, 'slow');
    this.activeLink = val;
    this.refundPolicy.show();
  }
  refundPolicylinkClose(val: number) {
    this.activeLink = val;
    this.refundPolicy.hide();
  }

  shippingPolicylink(val: number) {
    $('#shippingpolicymodal').animate({
      scrollTop: 0
    }, 'slow');
    this.activeLink = val;
    this.shippingPolicy.show();
  }

  shippingPolicylinkClose(val: number) {
    this.activeLink = val;
    this.shippingPolicy.hide();
  }

  aboutCopy(val: number) {
    $('#aboutinfomodal').animate({
      scrollTop: 0
    }, 'slow');
    this.activeLink = val;
    this.aboutInfo.show();
  }

  aboutCopyClose(val: number) {
    this.activeLink = val;
    this.aboutInfo.hide();
  }

  Contactinfo(val: number) {
    $('#contactinfomodal').animate({
      scrollTop: 0
    }, 'slow');
    this.activeLink = val;
    this.contactInfo.show();
  }

  ContactinfoClose(val: number) {
    this.activeLink = val;
    this.contactInfo.hide();
  }






  setPasswordEvt() {
    this.showLoader = true;
    this.setPassMsg = "";
    let apiUrl = this.configSetting.getBaseUrl() + "user/setPassword";
    let encodedPassword = this.encryptService.encrypt(this.password);
    let encodedUserId = this.encryptService.encrypt(this.userId + "");
    let encodedLanguage = this.encryptService.encrypt(this.prefLang);
    let body = {
      "xyzip": encodedPassword,
      "pqrln": encodedLanguage,
      "abcnum": encodedUserId
    }
    let param = { "criteria": body }
    this.authService.postMethod(apiUrl, param).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        // console.log("Set Password .....", JSON.stringify(successResp));
        this.loginSuccess = true;
        this.setPassMsg = "Your Password is set successfully, click on Login.";
      }
    }, (err) => {
      //      console.log(err);
      this.showLoader = false;
    })
  }


  setPasswordModalCloseEvt() {
    this.loginSuccess = false;
    this.setPassMsg = "";
    this.loginEmailId = "";
    this.password = "";
    this.confPassword = "";
    this.passwordMatch = false;
    this.setPasswordModal.hide();
    this.verificationModal.hide();
  }
  loginFromSetPasswordModal() {
    this.loginSuccess = false;
    this.setPassMsg = "";
    this.loginPassword = this.password;
    this.password = "";
    this.confPassword = "";
    this.passwordMatch = false;
    this.setPasswordModal.hide();
    this.logInEvt();
  }

  resetReg() {
    // this.emailId = "";
    this.userName = "";
    this.authCode = "";
    this.infoMsg = "";
    this.ErrorMsg = "";
    this.password = "";
    this.confPassword = "";
    this.passCheckImgSrc = "";
    this.regEmailImgSrc = "";
    this.loginEmailImgSrc = "";
    this.regStatus = "";
  }



  changeViewOfPasswrd(FOR, typeForPassword) {
    if (typeForPassword == 'password') {
      if (FOR == 'pass') {
        this.typeForPassword = 'text';
      }
      else {
        this.typeForConPassword = 'text';
      }
    }
    else {
      if (FOR == 'pass') {
        this.typeForPassword = 'password';
      }
      else {
        this.typeForConPassword = 'password';
      }
    }
  }

  cleaField(type: string) {
    // console.log(type);

    type = '';
    type = null;
    // switch (type) {
    //   case 'password':
    //       this.password = '';
    //     break;
    //     case 'confirmpassword':
    //       this.confPassword = '';
    //     break;
    //   default:
    //     break;
    // }
  }

  clickToOpenForgotPass() {
    this.forgotPassword();
    this.ForgotEmailInMsg = "";

  }

  closeSuccessModal() {
    this.successModal.hide();
    this.chooseLoginOption();
  }

  updateTime(time) {
    let min = Math.floor(time / 60).toString()
    let sec = Math.floor(time % 60).toString();

    min = min.length == 1 ? ("0" + min) : min;
    sec = sec.length == 1 ? ("0" + sec) : sec;

    this.showTime = `${min + ':' + sec}`;
    if (min == '00' && sec == '00') {
      this.resendBtnDisable = false;
      this.showtimeline = false;
      return;
    }

    this.time--;
  }


  showForgotPassLink() {
    this.forgotPassVisible = true;

    if (!this.loginEmailId) {
      this.forgotPassVisible = false;
    }
  }

}
